/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';
import { useNotifications } from '../../context/NotificationsContext';

const CATEGORIES = ['ACCOUNT','BOT_RUN','BOT_SIGNAL','INDICATOR_ALERT','BACKTEST','RISK','SYSTEM','BILLING'];
const SEVERITIES = ['INFO','NOTICE','WARNING','ERROR','CRITICAL'];

export default function NotificationsPreferences() {
  const { preferences, upsertPreference } = useNotifications();

  const getPref = (category) => preferences?.find(p => p.channel === 'WEB' && p.category === category) || { channel: 'WEB', category, enabled: true, min_severity: 'INFO' };

  const toggleEnabled = async (category, enabled) => {
    await upsertPreference({ ...getPref(category), enabled });
  };
  const changeSeverity = async (category, min_severity) => {
    await upsertPreference({ ...getPref(category), min_severity });
  };

  return (
    <div className="space-y-3">
      {CATEGORIES.map((cat) => {
        const pref = getPref(cat);
        return (
          <div key={cat} className="p-3 border border-borderDefault rounded">
            <div className="flex items-center gap-3">
              <div className="font-medium w-40">{cat}</div>
              <label className="flex items-center gap-2">
                <input type="checkbox" checked={!!pref.enabled} onChange={(e) => toggleEnabled(cat, e.target.checked)} />
                <span>Enable (WEB)</span>
              </label>
              <label className="flex items-center gap-2 ml-auto">
                <span className="text-sm text-textSecondary">Min severity</span>
                <select className="text-sm border border-borderDefault rounded px-2 py-1 bg-backgroundBody" value={pref.min_severity}
                        onChange={(e) => changeSeverity(cat, e.target.value)}>
                  {SEVERITIES.map((s) => (<option key={s} value={s}>{s}</option>))}
                </select>
              </label>
            </div>
          </div>
        );
      })}

      <div className="p-3 border border-dashed border-borderDefault rounded text-sm text-textSecondary">
        Trade email preferences are available on your profile page.
      </div>
    </div>
  );
}
